import Trigger from '../../components/Modals/payments/Triggers';
const Description = ({
  campaignData,
  handlePaymentClick,
  recurrence,
  setRecurrence,
}) => {
  return (
    <div className='description-container'>
      {campaignData.stage === 4 && (
        <>
          <a
            className='btn primary results'
            href={`/results/${campaignData.name}`}>
            resultados
          </a>
          <div className='titles'>
            <h4>Causa</h4>
            <h4>Ubicación</h4>
            <h4>Población</h4>
          </div>

          <div className='info'>
            <p>{campaignData.ods[0].label}</p>
            <p>{campaignData.location}</p>
            <p>{campaignData.location}</p>
          </div>
        </>
      )}
      <div className='objective'>
        <h3>Objetivo</h3>
        <p>{campaignData.objective}</p>
      </div>
      {(campaignData.stage === 1 || campaignData.stage === 2) && (
        <Trigger
          campaign={campaignData.name}
          campaignId={campaignData._id}
          foundation={campaignData.foundation.name}
          foundationId={campaignData.foundation._id}
        />
      )}
    </div>
  );
};

export default Description;
